export default {
  isFeatureItinerariesEnabled: process.env.VUE_APP_FEATURE_ITINERARIES_ENABLED === 'true',
  isFeatureFeedbackEnabled: process.env.VUE_APP_FEATURE_FEEDBACK_ENABLED === 'true'
}
